import request from '@/utils/request';

// GraphQL
export async function graphQlAll(params) {
  return request.post('/api/graphql/all', {
    ...params,
  });
}
// 查询协议或者隐私内容
export function getWebContentByCode(params) {
  return request.post("/openapi/basic/cmsWebContent/selContentByCode/manage", {
    ...params,
  });
}
